// конфигурация сборки ngx
const conf = require('./conf');
const packageJSON = require('../package.json');
let devConf;

try {
	devConf = require('./dev.conf');
} catch (e) {
	if (e.code === 'MODULE_NOT_FOUND') {
		devConf = {};
	} else {
		throw e;
	}
}

const mergedConf = {
	...conf,
	...devConf,
	buildConfig: {
		...(conf.buildConfig || {}),
		...(devConf.buildConfig || {}),
	},
	userData: {
		...(conf.userData || {}),
		...(devConf.userData || {}),
	}
};

/**
 * @type IBuildConfiguration
 */
module.exports = {
	isProductionMode: false,
	devspecs: mergedConf.devspecs,
	language: mergedConf.buildConfig.language,
	proxy: {
		server: mergedConf.buildConfig.server,
		port: mergedConf.buildConfig.port,
		https: mergedConf.buildConfig.https,
		targets: mergedConf.buildConfig.proxyTargets,
		webSockets: mergedConf.buildConfig.webSockets
	},
	bankroAuth: {
		login: mergedConf.buildConfig.login,
		password: mergedConf.buildConfig.password,
	},
	meetingsAuth: {
		PhoneNumber: mergedConf.userData.PhoneNumber,
		Password: mergedConf.userData.Password,
		IsGuest: mergedConf.userData.IsGuest,
		GuestCookieName: mergedConf.userData.GuestCookieName,
		GuestCookieValue: mergedConf.userData.GuestCookieValue,
		GuestCookieOptions: mergedConf.userData.GuestCookieOptions,
		...getMeetingsAuthHelperParams(mergedConf.buildConfig.server)
	},
	installedModules: [],
	browsers: packageJSON.browserslist
};

/**
 * @param serverUrl: string
 * @returns {{prependedUrl: string, cookieSuffix: string}}
 */
function getMeetingsAuthHelperParams (serverUrl) {
	const prependUrlRegExp = /https?:\/\/[^\/]*\/([\w\d-]*)/;
	const result = {
		prependedUrl: '',
		cookieSuffix: '',
	};
	const prependedUrl = prependUrlRegExp.exec(serverUrl); // может быть null

	if (prependedUrl && prependedUrl[1]) {
		result.prependedUrl = prependedUrl[1] + '/';
		result.cookieSuffix = prependedUrl[1];
	} else {
		const portRegExp = /https?:\/\/[^:]*:([\w\d]*)/;
		const nonStandartPort = portRegExp.exec(serverUrl);
		if (nonStandartPort) {
			result.cookieSuffix = nonStandartPort[1];
		}
	}

	return result;
}
